/**
 * IGNIERE §302 お気に入り（2026-10-09・代表の要件 4 つ）
 *   ① 登録ボタンは商品ページのカートのボタンの直下（templates/product.json の ig_wishlist）
 *   ② 登録されたことが目で分かる＝ボタンの絵と文言が変わる・ヘッダーの印に数が出て、増えた時に弾む
 *   ③ もう一度押すと解除
 *   ④ 一覧は横から出るドロワー（カートのドロワーと同じ Horizon の <theme-drawer>・中身は簡素）
 * §302-2（同日・代表承認の 4 点）：ドロワーの行に「カートに入れる」（種類が複数なら選ぶ欄）・セールの元値・
 *   ゲストだけ上にログインの案内・いちばん下に CHECKED ITEMS（閲覧の記録の横送り）。共有は入れない（代表）。
 * §302-5（同日・代表承認）：お気に入りは色×サイズ（種類）ごと（Swish の wishlist_mode＝VARIANT）。商品ページのハートは今選んでいる種類に従い、
 *   選ぶ部品（色の写真の札・サイズのボタン）に保存済みの印。ドロワーは保存した色の写真＋「カラー：…／サイズ：…」＋そのままカートへ（選ぶ欄は置かない）。
 * §302-3（同日・代表承認）：操作は下の段 1 本（カートアイコン＋「カートに入れる」・ゴミ箱）・選ぶ欄はカラーとサイズを別々に
 *   （売り切れの組み合わせは「（売り切れ）」を添えて選べる＝商品ページと同じ）・閲覧の記録を 20 件に。
 *
 * 保存の台帳は Swish（旧 Wishlist King・従来の作り 5.29）。見た目は全部テーマ側で持ち、Swish の画面部品は使わない。
 * 使う口（wishlist-app.js を読んで確認・2026-10-09 に開発テーマで往復を実測）：
 *   window.WishlistKing.state.observeWishlist({wishlistId:'mine'}).subscribe(w => …)  w = {numItems, items:[{id, product:{…}}]}
 *   window.WishlistKing.state.observeProductInfo({productHandle}).subscribe(p => …)  p = {inWishlist, wishlistItemId}
 *   window.WishlistKing.state.addWishlistItem({productHandle}) / removeWishlistItem({wishlistItemId})
 *   起動の知らせ＝document の 'wk:app:ready'（Swish は LAZY 読み込み）
 * 往復は 1 回 約 1.4 秒＝押した瞬間に表示を切り替え、失敗したら戻す。
 *
 * Horizon コアは触らない（掟 §3・経路①＝JS runtime）。ヘッダーの印の差し込みは snippets/igniere-wishlist-link.liquid（head で同期）。
 */
(function () {
  'use strict';
  if (window.__igWishlist) return;
  window.__igWishlist = true;

  var DRAWER_ID = 'ig-wishlist-drawer';
  var SCRIM_ID = 'ig-wishlist-scrim';
  var MIN_SCRIM = 481; // これ未満はドロワーが全画面＝膜の出番が無い（カートと同じ・§164-9）
  var CFG = (function () {
    try { return JSON.parse(document.getElementById('ig-wishlist-config').textContent); } catch (e) { return {}; }
  })();
  var ALL_URL = CFG.allUrl || '/collections/all';
  var CART_ADD_URL = CFG.cartAddUrl || '/cart/add.js';
  var CART_URL = CFG.cartUrl || '/cart';
  var HISTORY_KEY = 'ig_recently_viewed_v1'; // 商品ページの CHECKED ITEMS（sections/igniere-pdp-checked.liquid）が書く閲覧の記録
  // オプション名を日本語に（§16.32＝カートの明細と同じ・assets/igniere-cart-overlay.js の OPTION_JA の写し）
  var OPTION_JA = { COLOR: 'カラー', COLOUR: 'カラー', SIZE: 'サイズ', '色': 'カラー', 'カラー': 'カラー', 'サイズ': 'サイズ' };
  var ARROW = '<svg viewBox="0 0 14 14" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="square" aria-hidden="true" focusable="false"><polyline points="5.25,3.5 8.75,7 5.25,10.5"/></svg>';
  // カートに入れるボタンのカートアイコン＝店の全部のカートに入れるボタンと同じ S1（design-components §16.11-5・台帳 §394・2026-10-28 代表「揃えるに決まっているでしょう。」）・カートの明細と同じゴミ箱の絵（assets/icon-delete.svg）
  var BAG = '<svg class="ig-wl-ico" viewBox="0 0.5 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true" focusable="false"><path d="M19 11.9V8H5v13h6.9"/><path d="M9 11V6.5a3 3 0 0 1 6 0V11"/><path d="M19 16.5v5M16.5 19h5"/></svg>';
  var BELL = '<svg class="ig-wl-ico" viewBox="0 0 20 20" width="18" height="18" fill="none" aria-hidden="true" focusable="false"><path d="M10 3.25a4.25 4.25 0 0 0-4.25 4.25v2.9L4.5 13.25h11l-1.25-2.85V7.5A4.25 4.25 0 0 0 10 3.25Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M8.25 15.5a1.75 1.75 0 0 0 3.5 0" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';
  var TRASH = '<svg class="ig-wl-ico" viewBox="0 0 20 20" width="20" height="20" fill="none" aria-hidden="true" focusable="false"><path d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><path d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var app = null;          // window.WishlistKing
  var wishlist = { numItems: 0, items: [] };
  var lastCount = null;
  var removing = {};      // 削除を押して処理待ちの行（一覧と数からすぐ外す＝押した通りに見せる）
  var adding = {};        // カートに入れている途中の行
  var notes = {};         // 行の下に出す一言（「サイズを選んでください」・カートに入れられなかった理由）
  var live = null;

  /* ── 読み上げ（登録・解除を耳でも分かるように） ── */
  function say(msg) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function yen(cents) {
    var n = Math.round(Number(cents || 0) / 100);
    return '¥' + n.toLocaleString('ja-JP');
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  /* ── Swish の起動を待つ（読み込みの前後どちらでも動く） ── */
  function whenReady(cb) {
    if (window.WishlistKing && window.WishlistKing.state) { cb(window.WishlistKing); return; }
    document.addEventListener('wk:app:ready', function () {
      if (window.WishlistKing) cb(window.WishlistKing);
    }, { once: true });
  }
  // §317-9（デバッグ A5）Swish が読めない時（広告ブロッカー・通信の失敗）に、黙って無反応・永遠に「読み込み中」にしない。
  // 起動から 10 秒たっても台帳が届かなければ「読み込めませんでした」に切り替える（後から届けば普段どおりに戻る）
  var appFailed = false;
  var READY_LIMIT = 10000;

  /* ── 操作の列（2026-10-09 実測で見つけた Swish の癖への手当て） ──
     Swish（wishlist-app.js 5.29）は、1 つの操作の後に台帳を読み直し終えるまで、次の add／remove を
     **何も言わずに捨てる**（戻り値が undefined・エラーも出ない）。起動の直後も同じ。
     そのまま使うと「素早く 2 回押した 2 回目」「読み込み直後の 1 回目」が保存されないのに保存済みと表示される。
     → 操作を 1 本の列に並べ、捨てられたら 250ms 待ってやり直す（最大 約 8 秒）。成功は戻り値があることで判定する。 */
  var chain = Promise.resolve();
  /* §402（2026-11-02）保存先（api.appmate.io）に届かない時、Swish の SDK は失敗を返さずに黙り、仮の 1 件（id が temp-…）を
     台帳に置いたままにする＝失敗の分岐に入らず、バッジ「1」とドロワーの「追加しています」が残り続けた（クラウドの操作テスト P1-4・
     本番で保存先を止めて 11 秒後も残るのを実測）。→ 1 回の操作に期限を設け、期限を過ぎたら失敗として扱い、
     仮の 1 件を数と一覧から外す（failedPending）。次に台帳が仮の行の無い形で届くか、次の操作が成功したら、元に戻す。 */
  var DEADLINE = 10000;
  var failedPending = false;
  function withDeadline(job) {
    return new Promise(function (res, rej) {
      var t = setTimeout(function () { rej(new Error('swish timeout')); }, DEADLINE);
      job.then(function (r) { clearTimeout(t); res(r); }, function (e) { clearTimeout(t); rej(e); });
    });
  }
  function isTemp(it) { return !(it.product && it.product.title); }
  function attempt(call, n) {
    return Promise.resolve(call()).then(function (r) {
      if (r !== undefined) return r;
      if (n >= 32) throw new Error('swish busy');
      return new Promise(function (res) { setTimeout(res, 250); }).then(function () { return attempt(call, n + 1); });
    });
  }
  function act(call) {
    var job = chain.then(function () { return withDeadline(attempt(call, 0)); });
    chain = job.catch(function () {});
    return job;
  }
  /* ── §302-5 保存は色×サイズ（種類）ごと（Swish の wishlist_mode＝VARIANT・代表 2026-10-09） ── */
  function itemsOf(handle) {
    return visibleItems().filter(function (it) { return it.product && it.product.handle === handle; });
  }
  // 保存した 1 件の種類。種類の番号が無い古い保存（商品単位）は、種類が 1 つの商品だけその種類とみなす
  function variantOfItem(it) {
    var vs = (it.product && it.product.variants) || [];
    if (it.variantId) for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(it.variantId)) return vs[i];
    return vs.length === 1 ? vs[0] : null;
  }
  function itemFor(handle, variantId) {
    var list = itemsOf(handle);
    for (var i = 0; i < list.length; i++) {
      var v = variantOfItem(list[i]);
      if (v && String(v.id) === String(variantId)) return list[i];
    }
    return null;
  }
  function optOf(v, i) { return v && v['option' + (i + 1)]; }
  // 商品ページの全種類（初めての保存で台帳にまだ商品が無い時の印に使う）＝選ぶ部品の data-variant-id ではなく、ページの商品 JSON から
  var pageVariants = null;
  function variantsOnPage() {
    if (pageVariants) return pageVariants;
    var el = document.querySelector('#ig-wl-product-json');
    try { pageVariants = el ? JSON.parse(el.textContent) : []; } catch (e) { pageVariants = []; }
    return pageVariants;
  }

  /* ================= ① ② ③ 商品ページのボタン ================= */
  // 今選んでいる種類＝選ぶ部品で今押されている値の組み合わせ（押した瞬間に変わる）。
  // カートのフォームの種類は Horizon が店へ問い合わせた後（約 1 秒後・375 幅で実測）に書き換わるので、
  // それを読むと、選び直した直後にハートを押した時に前の種類で保存してしまう。部品が無い商品（種類 1 つ）はフォームから
  function currentVariantId() {
    var checked = document.querySelectorAll('#MainContent variant-picker fieldset[data-fieldset-index] input:checked');
    var vs = variantsOnPage();
    if (checked.length && vs.length) {
      var want = [];
      checked.forEach(function (x) { want[Number(x.getAttribute('data-fieldset-index'))] = x.value; });
      for (var i = 0; i < vs.length; i++) {
        var ok = true;
        for (var k = 0; k < want.length; k++) if (want[k] != null && optOf(vs[i], k) !== want[k]) { ok = false; break; }
        if (ok) return String(vs[i].id);
      }
    }
    var inp = document.querySelector('#MainContent product-form-component input[ref="variantId"], #MainContent product-form-component input[name="id"]');
    return inp && inp.value ? inp.value : null;
  }

  // §302-5 選ぶ部品（色の写真の札・サイズのボタン）の上に、保存済みの印（小さなハート）を付ける。
  // 1 段目（色）＝その色の種類が 1 つでも保存されていれば印。2 段目以降（サイズ）＝今選んでいる上の段と同じで、その値の種類が保存されていれば印。
  // Horizon は選び直すたびに選ぶ部品を描き直す（morph）ので、描き直しの後にも付け直す
  // 中に svg を置かない＝Horizon の「売り切れの斜線」用の指定（選ぶ部品の中の svg を左上へ寄せる）が当たってハートが丸からずれた（§302-6）。形は CSS の切り抜き
  var MARK = '<span class="ig-wl-mark" aria-hidden="true"></span>';
  function paintMarks(handle, fresh, opt) {
    var picker = document.querySelector('#MainContent variant-picker');
    if (!picker) return;
    var items = itemsOf(handle).filter(function (it) { return !(opt && opt.removeId && it.id === opt.removeId); });
    var saved = items.map(variantOfItem).filter(function (v) { return v; });
    // 押した直後（台帳の返事の前）も、押した通りに印を出す
    if (opt && opt.add) {
      // 種類の一覧はページの JSON を先に使う（Swish が入れた直後に出す仮の 1 件は種類の情報を持たない＝実測）
      var all = variantsOnPage();
      if (!all.length) all = (items[0] && items[0].product && items[0].product.variants) || [];
      for (var q = 0; q < all.length; q++) if (String(all[q].id) === String(opt.add)) { saved.push(all[q]); break; }
    }
    var sets = picker.querySelectorAll('fieldset[data-fieldset-index]');
    var chosen = [];
    sets.forEach(function (fs) {
      var c = fs.querySelector('input:checked');
      chosen[Number(fs.getAttribute('data-fieldset-index'))] = c ? c.value : null;
    });
    sets.forEach(function (fs) {
      var k = Number(fs.getAttribute('data-fieldset-index'));
      fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var on = saved.some(function (v) {
          if (optOf(v, k) !== inp.value) return false;
          for (var u = 0; u < k; u++) if (optOf(v, u) !== chosen[u]) return false;
          return true;
        });
        var label = inp.closest('label') || inp.parentElement;
        var had = label.classList.contains('ig-wl-saved');
        var old = label.querySelector(':scope > .ig-wl-mark');
        if (on && !old) label.insertAdjacentHTML('beforeend', MARK);
        if (!on && old) old.remove();
        label.classList.toggle('ig-wl-saved', on);
        if (on && !had && fresh) {
          var m = label.querySelector(':scope > .ig-wl-mark');
          if (m) { m.classList.remove('is-new'); void m.offsetWidth; m.classList.add('is-new'); }
        }
      });
    });
  }

  function bindButton(btn) {
    if (btn.dataset.igWlBound) return;
    btn.dataset.igWlBound = '1';
    var handle = btn.getAttribute('data-ig-wl-handle');
    var state = { saved: false, busy: false, opt: null }; // opt＝押した直後の見込み（add＝入れた種類／removeId＝外した 1 件）

    // ハートは「今選んでいる種類」が保存済みの時だけ塗る（選び直すと従う）
    function paint(fresh) {
      var o = state.opt;
      // 台帳が押した通りになったら、見込みを外す
      if (o && !state.busy && ((o.add && itemFor(handle, o.add)) || (o.removeId && !itemsOf(handle).some(function (it) { return it.id === o.removeId; })))) state.opt = o = null;
      var vid = currentVariantId();
      // §317-9（デバッグ A2）押して保存している途中でも、今選んでいる種類で塗り分ける
      // （前は途中の約 1.4 秒、別のサイズへ替えても塗ったままだった）。押した種類の見込みは opt が持つ
      var hit = itemFor(handle, vid);
      if (o && o.removeId && hit && hit.id === o.removeId) hit = null;
      state.saved = !!hit || !!(o && o.add && String(o.add) === String(vid));
      btn.setAttribute('aria-pressed', state.saved ? 'true' : 'false');
      btn.classList.toggle('is-saved', state.saved);
      paintMarks(handle, fresh, o);
    }
    btn.__igPaint = paint;

    btn.addEventListener('click', function () {
      // 保存の途中に押されたら、終わってからもう一度押したことにする（黙って捨てない＝デバッグ A2）
      if (state.busy) { state.again = true; return; }
      if (!app && appFailed) { say('お気に入りを読み込めませんでした。時間をおいて、ページを読み込み直してください'); return; }
      whenReady(function (a) {
        if (state.busy) return;
        var vid = currentVariantId();
        var hit = itemFor(handle, vid);
        state.busy = true;
        var willSave = !hit;
        state.saved = willSave; // 先に表示を切り替える（往復 約 1.4 秒を待たせない）
        state.opt = willSave ? { add: vid } : { removeId: hit.id };
        btn.setAttribute('aria-pressed', willSave ? 'true' : 'false');
        btn.classList.toggle('is-saved', willSave);
        paintMarks(handle, true, state.opt); // 押した瞬間に、選んでいる部品へ印を灯す
        var job = willSave
          ? act(function () { return a.state.addWishlistItem({ productHandle: handle, variantId: vid ? Number(vid) : undefined }); })
          : act(function () { return a.state.removeWishlistItem({ wishlistItemId: hit.id }); });
        job.then(function () {
          failedPending = false;
          say(willSave ? (variantWords() + 'お気に入りに追加しました') : 'お気に入りから外しました');
        }).catch(function () {
          state.opt = null; // 失敗＝見込みを捨てて台帳の通りに戻す
          if (willSave) { failedPending = true; paintBadges(); renderList(); } // §402 仮の 1 件を数と一覧から外す
          say('うまく保存できませんでした。もう一度お試しください');
        }).then(function () {
          state.busy = false;
          // 台帳の知らせが届くまでの間、押した後の見た目を保つ（届けば paint が台帳に合わせ直す）
          setTimeout(function () {
            paint(true);
            if (state.again) { state.again = false; btn.click(); }
          }, 0);
        });
      });
    });
  }
  // 読み上げ用の色とサイズ（画面には文を足さない）＝選ぶ部品で今選んでいる値
  function variantWords() {
    var vals = Array.prototype.map.call(document.querySelectorAll('#MainContent variant-picker fieldset input:checked'), function (x) { return x.value; });
    return vals.length ? vals.join('・') + ' を' : '';
  }
  function bindButtons(root) {
    (root || document).querySelectorAll('.ig-wl-btn[data-ig-wl-handle]').forEach(bindButton);
  }
  function repaintButtons(fresh) {
    document.querySelectorAll('.ig-wl-btn[data-ig-wl-handle]').forEach(function (b) { if (b.__igPaint) b.__igPaint(fresh); });
  }

  /* ================= ② ヘッダーの印と数 ================= */
  function visibleItems() {
    return (wishlist.items || []).filter(function (it) { return !removing[it.id] && !(failedPending && isTemp(it)); });
  }
  function paintBadges() {
    var n = visibleItems().length;
    var grew = lastCount !== null && n > lastCount;
    lastCount = n;
    document.querySelectorAll('.ig-wl-link').forEach(function (link) {
      var b = link.querySelector('.ig-wl-badge');
      link.setAttribute('aria-label', n > 0 ? 'お気に入り（' + n + ' 点）' : 'お気に入り');
      if (!b) return;
      b.textContent = n > 99 ? '99+' : String(n);
      b.hidden = n === 0;
      if (grew) {
        b.classList.remove('is-bump');
        void b.offsetWidth; // 同じ class をもう一度効かせる
        b.classList.add('is-bump');
      }
    });
  }

  /* ================= ④ ドロワー ================= */
  function drawer() { return document.getElementById(DRAWER_ID); }

  function ensureDrawer() {
    var d = drawer();
    if (d) return d;
    d = document.createElement('theme-drawer');
    d.id = DRAWER_ID;
    d.setAttribute('no-persist', ''); // ページを移っても開き直さない（Horizon の復元から外す）
    d.setAttribute('data-skip-node-update', '');
    d.innerHTML =
      '<dialog ref="panel" class="theme-drawer__dialog color-custom-drawer ig-wl-drawer" aria-labelledby="ig-wl-heading">' +
        '<div class="theme-drawer__header">' +
          '<h2 class="theme-drawer__title h4" id="ig-wl-heading">お気に入り<span class="theme-drawer__badge" aria-hidden="true" hidden></span></h2>' +
          '<button type="button" class="theme-drawer__close-button" aria-label="閉じる"></button>' +
        '</div>' +
        '<div class="ig-wl-drawer__body"></div>' +
      '</dialog>';
    document.body.appendChild(d);
    d.querySelector('.theme-drawer__close-button').addEventListener('click', function () { d.close(); });
    d.querySelector('.ig-wl-drawer__body').addEventListener('click', onListClick);
    // 開閉に合わせて膜・ヘッダーの印の aria-expanded・焦点の当て先を整える
    new MutationObserver(function () { syncOpen(d); }).observe(d, { attributes: true, attributeFilter: ['open'] });
    renderList();
    return d;
  }

  function ensureScrim() {
    var el = document.getElementById(SCRIM_ID);
    if (el) return el;
    el = document.createElement('div');
    el.id = SCRIM_ID;
    el.setAttribute('aria-hidden', 'true');
    el.addEventListener('click', function () { var d = drawer(); if (d) d.close(); });
    document.body.appendChild(el);
    return el;
  }

  function syncOpen(d) {
    var open = d.hasAttribute('open');
    ensureScrim().classList.toggle('is-on', open && window.innerWidth >= MIN_SCRIM);
    document.querySelectorAll('.ig-wl-link').forEach(function (l) { l.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) {
      requestAnimationFrame(function () { updateChecked(d); }); // 閉じている間は幅が 0＝送りの矢印の要否は開いてから測る
      // §16.24-6 開いたら焦点は器へ（Horizon は閉じるボタンへ当てる＝Safari で輪郭が出る・§186-2 と同じ直し）
      requestAnimationFrame(function () {
        var panel = d.querySelector('.theme-drawer__dialog');
        var close = d.querySelector('.theme-drawer__close-button');
        if (panel && document.activeElement === close) {
          panel.setAttribute('tabindex', '-1');
          panel.focus({ preventScroll: true });
        }
      });
    }
  }

  function openDrawer() {
    var d = ensureDrawer();
    // ほかのドロワー（カート）・かぶせ面（メニュー・検索・絞り込み）は閉じる＝同時に 1 面だけ（§16.24-1）
    document.querySelectorAll('theme-drawer[open]').forEach(function (o) {
      if (o !== d && typeof o.close === 'function') o.close();
    });
    if (window.__menuX) window.__menuX.announce('wishlist');
    if (typeof d.open === 'function') d.open();
  }
  function toggleDrawer() {
    var d = drawer();
    if (d && d.hasAttribute('open')) { d.close(); return; }
    openDrawer();
  }

  /* ── §302-2 行の中身の部品 ── */
  function optName(n) {
    var k = String(n || '');
    return OPTION_JA[k.toUpperCase()] || OPTION_JA[k] || k;
  }
  // 行の「カラー：Natural／サイズ：L」（§16.32 カートの明細と同じ書き方＝オプション名は日本語・全角のコロン・区切りは「／」）。
  // 種類が 1 つだけの「Title／Default Title」は出さない
  function variantLine(p, v) {
    if (!v) return '';
    var parts = [];
    (p.options || []).forEach(function (o, i) {
      var name = o && o.name;
      var val = optOf(v, i);
      if (!name || name === 'Title' || !val || val === 'Default Title') return;
      parts.push(optName(name) + '：' + val);
    });
    return parts.join('／');
  }
  // 値段：セールは元値に線（§16.3＝元値は暖グレー 400・売値は #9E3B34 700・元値が先＝snippets/price.liquid の既定の並び）
  function priceHtml(price, compare, from) {
    var sale = compare && Number(compare) > Number(price);
    return '<p class="ig-wl-line__price' + (sale ? ' is-sale' : '') + '">' +
      (sale ? '<s class="ig-wl-line__was"><span class="visually-hidden">通常価格</span>' + yen(compare) + '</s>' : '') +
      '<span class="ig-wl-line__now">' + (sale ? '<span class="visually-hidden">セール価格</span>' : '') + yen(price) + (from ? '〜' : '') + '</span>' +
      '<span class="ig-wl-line__tax">（税込）</span>' +
    '</p>';
  }

  /* ── §302-2 CHECKED ITEMS（ドロワーのいちばん下・小さい写真の横送り 1 段） ──
     中身は商品ページの CHECKED ITEMS と同じ閲覧の記録（最大 8 件）。お気に入りに入っている物と、今開いている商品は除く。
     記録が無ければ段ごと出さない。新作・特集などは足さない（ドロワーは簡素に＝代表の要件④） */
  function readHistory() {
    try {
      var list = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }
  function checkedHtml(items) {
    var skip = {};
    items.forEach(function (it) { if (it.product && it.product.handle) skip[it.product.handle] = true; });
    var here = document.querySelector('.ig-wl-btn[data-ig-wl-handle]');
    if (here) skip[here.getAttribute('data-ig-wl-handle')] = true;
    var list = readHistory().filter(function (x) { return x && x.handle && x.url && !skip[x.handle]; }).slice(0, 8);
    if (!list.length) return '';
    return '<section class="ig-wl-checked" aria-labelledby="ig-wl-checked-h">' +
      '<div class="ig-wl-checked__head">' +
        '<div class="ig-wl-checked__heading">' +
          '<h3 class="ig-wl-checked__title" id="ig-wl-checked-h">CHECKED ITEMS</h3>' +
          '<p class="ig-wl-checked__sub">最近チェックした商品</p>' +
        '</div>' +
        '<div class="ig-wl-checked__nav" hidden>' +
          '<button type="button" class="ig-wl-checked__arrow ig-wl-checked__arrow--prev" data-ig-wl-scroll="-1" aria-label="前へ">' + ARROW + '</button>' +
          '<button type="button" class="ig-wl-checked__arrow" data-ig-wl-scroll="1" aria-label="次へ">' + ARROW + '</button>' +
        '</div>' +
      '</div>' +
      '<ul class="ig-wl-checked__track" role="list">' + list.map(function (x) {
        return '<li class="ig-wl-checked__item"><a class="ig-wl-checked__link" href="' + esc(x.url) + '">' +
          '<span class="ig-wl-checked__im">' + (x.img ? '<img src="' + esc(x.img) + '" alt="" width="96" height="120" loading="lazy" decoding="async">' : '') + '</span>' +
          '<span class="ig-wl-checked__name">' + esc(x.title) + '</span>' +
        '</a></li>';
      }).join('') + '</ul>' +
    '</section>';
  }
  // 送りの矢印＝はみ出す時だけ・端では押せない（§16.26 役割 2 の PC の矢印。指で滑らせる端末では CSS が隠す）
  function updateChecked(d) {
    var track = d && d.querySelector('.ig-wl-checked__track');
    var nav = d && d.querySelector('.ig-wl-checked__nav');
    if (!track || !nav) return;
    var max = track.scrollWidth - track.clientWidth;
    nav.hidden = !(track.clientWidth > 0 && max > 1);
    nav.querySelector('[data-ig-wl-scroll="-1"]').disabled = track.scrollLeft <= 1;
    nav.querySelector('[data-ig-wl-scroll="1"]').disabled = track.scrollLeft >= max - 1;
  }

  // §404（2026-11-02）空のカートのドロワーにも同じ棚を出す口（assets/igniere-cart-overlay.js が呼ぶ）
  window.igCheckedShelf = function (host) {
    if (!host || host.querySelector('.ig-wl-checked')) return;
    var html = checkedHtml([]).replace(/ig-wl-checked-h/g, 'ig-cart-checked-h');
    if (!html) return;
    host.insertAdjacentHTML('beforeend', html);
    var sec = host.querySelector('.ig-wl-checked');
    var track = sec.querySelector('.ig-wl-checked__track');
    sec.addEventListener('click', function (e) {
      var arrow = e.target instanceof Element ? e.target.closest('[data-ig-wl-scroll]') : null;
      if (arrow && track) track.scrollBy({ left: Number(arrow.getAttribute('data-ig-wl-scroll')) * Math.max(track.clientWidth - 48, 96), behavior: 'smooth' });
    });
    if (track) track.addEventListener('scroll', function () { updateChecked(sec); }, { passive: true });
    updateChecked(sec);
    pruneChecked(sec);
  };

  function renderList() {
    var d = drawer();
    if (!d) return;
    var body = d.querySelector('.ig-wl-drawer__body');
    var badge = d.querySelector('.theme-drawer__badge');
    if (!app) { // 台帳が届く前に「空」と言わない
      body.innerHTML = appFailed
        ? '<p class="ig-wl-loading" role="alert">お気に入りを読み込めませんでした。時間をおいて、ページを読み込み直してください。</p>'
        : '<p class="ig-wl-loading" role="status">読み込み中</p>';
      return;
    }
    var items = visibleItems().slice().reverse(); // 新しく入れた物が上
    if (badge) { badge.textContent = String(items.length); badge.hidden = items.length === 0; }
    // ログインの案内＝ゲストの時だけ上に 1 行（ログインすると Swish の台帳がお客様の会員情報に付き、ほかの端末でも同じ一覧になる）
    var login = CFG.guest && CFG.loginUrl
      ? '<p class="ig-wl-login">ログインすると、他の端末でもご覧いただけます<a class="ig-wl-login__link" href="' + esc(CFG.loginUrl) + '">ログイン</a></p>'
      : '';
    var main;
    if (!items.length) {
      main =
        '<div class="ig-wl-empty">' +
          '<p class="ig-wl-empty__title">お気に入りに登録された商品はございません</p>' +
          '<p class="ig-wl-empty__text">気になる商品は、商品ページの<span class="ig-nw">「お気に入りに追加」</span>で残しておけます。</p>' +
          '<a class="button ig-wl-empty__cta" href="' + esc(ALL_URL) + '">商品を見る</a>' +
        '</div>';
    } else {
      main = '<ul class="ig-wl-list" role="list">' + items.map(lineHtml).join('') + '</ul>';
    }
    // §317-9（デバッグ A3）描き直しで、押したボタンからフォーカスが body へ落ちないように、同じ行の同じ操作へ戻す。
    // 行が消えた時（削除）は同じ位置の行の削除ボタン → 前の行 → ドロワーの器 の順
    var act0 = document.activeElement, keep = null;
    if (act0 && body.contains(act0)) {
      var row0 = act0.closest('.ig-wl-line');
      keep = {
        add: act0.getAttribute('data-ig-wl-add'), rm: act0.getAttribute('data-ig-wl-remove'),
        index: row0 ? Array.prototype.indexOf.call(body.querySelectorAll('.ig-wl-line'), row0) : -1
      };
    }
    body.innerHTML = login + main + checkedHtml(items);
    if (keep) restoreFocus(d, body, keep);
    var track = body.querySelector('.ig-wl-checked__track');
    if (track) track.addEventListener('scroll', function () { updateChecked(d); }, { passive: true });
    updateChecked(d);
    pruneChecked(d);
  }

  // §378（2026-10-26・設計書 7-4）公開をやめた・消した商品を CHECKED から外す（記録からも消す）。
  // ドロワーの CHECKED は写真と名前だけで値段を出さないので、確かめるのは「まだ店にあるか」だけ。
  // 店にあると分かった商品だけ覚えて聞き直さない（通信に失敗した商品は、次に描いた時にもう一度聞く・Codex の点検 ⑤）。
  // 答えが来た時は、その時に画面にあるドロワーから外す（聞いている間に描き直されても残さない）
  var checkedAlive = {};
  var checkedAsking = {};
  function handleOf(a) {
    var m = (a.getAttribute('href') || '').split('?')[0].match(/[/]products[/]([^/]+)$/);
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  function dropChecked(handle) {
    try {
      var list = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
      localStorage.setItem(HISTORY_KEY, JSON.stringify(list.filter(function (x) { return x && x.handle !== handle; })));
    } catch (e) {}
    var d = drawer();
    if (!d) return;
    Array.prototype.forEach.call(d.querySelectorAll('.ig-wl-checked__link'), function (a) {
      if (handleOf(a) !== handle) return;
      var li = a.closest('.ig-wl-checked__item');
      if (li) li.remove();
    });
    var sec = d.querySelector('.ig-wl-checked');
    if (sec && !sec.querySelector('.ig-wl-checked__item')) sec.remove();
    updateChecked(d);
  }
  function pruneChecked(d) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    Array.prototype.forEach.call(d.querySelectorAll('.ig-wl-checked__link'), function (a) {
      var handle = handleOf(a);
      if (!handle || checkedAlive[handle] || checkedAsking[handle]) return;
      checkedAsking[handle] = true;
      fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' }).then(function (r) {
        if (r.status === 404) dropChecked(handle);
        else if (r.ok) checkedAlive[handle] = true;
      }).catch(function () {}).then(function () { delete checkedAsking[handle]; });
    });
  }

  function restoreFocus(d, body, keep) {
    var sel = keep.add ? '[data-ig-wl-add="' + keep.add + '"]' : keep.rm ? '[data-ig-wl-remove="' + keep.rm + '"]' : null;
    var el = sel && body.querySelector(sel);
    if (el && el.disabled) { var row = el.closest('.ig-wl-line'); el = row && row.querySelector('.ig-wl-line__remove'); }
    if (!el && keep.index >= 0) {
      var rows = body.querySelectorAll('.ig-wl-line');
      var r = rows[Math.min(keep.index, rows.length - 1)];
      el = r && r.querySelector('.ig-wl-line__remove');
    }
    if (!el) {
      el = d.querySelector('.theme-drawer__dialog');
      if (el) el.setAttribute('tabindex', '-1');
    }
    if (el && document.activeElement !== el) el.focus({ preventScroll: true });
  }

  /* §317-11 売り切れの行の再入荷通知の入口（代表 2026-10-13）
     商品ページのボタンと同じ判定＝取扱区分（custom.handling）が「継続」か空の商品だけ。お気に入りの台帳（Swish）の商品の情報には
     取扱区分が無いので、売り切れの行の商品だけ /products/<handle>?view=ig-handling（templates/product.ig-handling.liquid）に聞く。
     答えが届くまでと、聞けなかった時は「売り切れ」のまま（再入荷しない商品に入口を出す側へは倒さない） */
  var handlingOf = {};
  function askHandling(handle) {
    if (!handle || handlingOf[handle]) return;
    handlingOf[handle] = 'asking';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Accept: application/json を付けると、Shopify は ?view を無視して商品の標準の JSON を返す（2026-10-13 実測）＝付けない
    fetch(root + 'products/' + encodeURIComponent(handle) + '?view=ig-handling')
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { handlingOf[handle] = (j && typeof j.handling === 'string') ? j.handling : 'unknown'; })
      .catch(function () { handlingOf[handle] = 'unknown'; })
      .then(function () { renderList(); });
  }

  // §406 ブランドの無い商品は商品カードとカートの行と同じく商品タイプ（blocks/_igniere-card-category.liquid・§270）
  function brandLabel(p) {
    var v = String(p.vendor || '').trim();
    return v && v.toUpperCase() !== 'NO BRAND' ? v : (p.type || '');
  }

  function lineHtml(it) {
    var p = it.product || {};
    // §389（2026-10-27・代表の実機「追加直後に一覧を開くと、商品名・画像が空で『¥0（税込）』」）
    //   Swish は追加した瞬間に仮の行（id が temp-…・product は 3 項目で名前も値段も無い）を先に渡し、約 2.3 秒後に本物に替える（開発テーマで実測）。
    //   仮の行は値段を描かず「追加しています」だけ＝誤った値段を見せない。操作（カート・削除）も本物が届いてから
    if (!p.title) {
      return '<li class="ig-wl-line is-pending" aria-busy="true">' +
        '<span class="ig-wl-line__img" aria-hidden="true"></span>' +
        '<div class="ig-wl-line__body"><p class="ig-wl-line__pending" role="status">お気に入りに追加しています</p></div>' +
      '</li>';
    }
    var id = esc(it.id);
    var v = variantOfItem(it); // 保存した種類（色×サイズ）
    var base = p.url || ('/products/' + p.handle);
    var url = v ? base + (base.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + v.id : base; // 保存した種類を選んだ状態で開く
    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image; // 写真は保存した色
    var price = v ? priceHtml(v.price, v.compare_at_price, false) : priceHtml(p.price_min, p.compare_at_price_min, p.price_varies);
    var line = variantLine(p, v);
    var note = notes[it.id]
      ? '<p class="ig-wl-line__note' + (notes[it.id].ok ? ' is-ok' : '') + '" role="' + (notes[it.id].ok ? 'status' : 'alert') + '">' + esc(notes[it.id].text) + '</p>'
      : '';
    // §302-5 操作は 1 つ＝保存した種類をそのままカートへ。売り切れはその種類の売り切れ。
    // 種類の番号が無い古い保存（商品単位・種類が複数）だけは、商品ページで選んでもらう
    var add;
    if (!v) add = '<a class="ig-wl-line__add" href="' + esc(base) + '">' + BAG + '<span class="ig-wl-line__add-text">色とサイズを選ぶ</span></a>';
    else if (!v.available || p.available === false) {
      // 売り切れ＝再入荷の見込みがある商品だけ、その種類を選んだ商品ページの登録欄へ（商品ページでも売り切れの種類はカートの段の代わりに登録のボタンだけ）
      var h = handlingOf[p.handle];
      if (!h) askHandling(p.handle);
      add = h === '継続'
        ? '<a class="ig-wl-line__add ig-wl-line__add--restock" href="' + esc(url) + '#ig-restock"><span class="visually-hidden">売り切れ。</span>' + BELL + '<span class="ig-wl-line__add-text">再入荷通知を受け取る</span></a>'
        : '<span class="ig-wl-line__soldtag">売り切れ</span>';
    }
    else add = '<button type="button" class="ig-wl-line__add" data-ig-wl-add="' + id + '" aria-label="' + esc(p.title) + (line ? '（' + esc(line) + '）' : '') + 'をカートに入れる"' +
      (adding[it.id] ? ' disabled aria-busy="true"' : '') + '>' + BAG +
      '<span class="ig-wl-line__add-text">' + (adding[it.id] ? 'カートに入れています' : 'カートに入れる') + '</span></button>';
    return '<li class="ig-wl-line">' +
      '<a class="ig-wl-line__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + esc(sized(img, 256)) + '" alt="" width="128" height="160" loading="lazy">' : '') +
      '</a>' +
      '<div class="ig-wl-line__body">' +
        (brandLabel(p) ? '<p class="ig-wl-line__brand">' + esc(brandLabel(p)) + '</p>' : '') +
        '<a class="ig-wl-line__name" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
        (line ? '<p class="ig-wl-line__variant">' + esc(line) + '</p>' : '') +
        price + note +
        '<div class="ig-wl-line__foot">' + add +
          '<button type="button" class="ig-wl-line__remove" data-ig-wl-remove="' + id + '" aria-label="' + esc(p.title) + (line ? '（' + esc(line) + '）' : '') + 'をお気に入りから削除">' + TRASH + '</button>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  function findItem(id) {
    var items = wishlist.items || [];
    for (var i = 0; i < items.length; i++) if (String(items[i].id) === String(id)) return items[i];
    return null;
  }

  /* ── §302-2 カートに入れる（Horizon の定石に乗る） ──
     商品ページのカートのボタン（assets/product-form.js）と同じ順で動く＝
     ① @shopify/events の CartLinesUpdateEvent を出す（約束の promise 付き・部品は Liquid の module から受け取る）
     ② /cart/add.js へ入れる（カートの明細の区画も一緒に頼む）
     ③ /cart.js で全体を読み直し、promise を解く
     → ヘッダーのカートの数（cart-icon.js）・カートの明細（component-cart-items.js）・カートのドロワーの自動で開く動き（cart-drawer.js）は
       Horizon 側がこの知らせで動く。コアは触らない。 */
  // 知らせの部品は snippets/igniere-wishlist-link.liquid の小さな module が window.__igCartEvents に置く（§302-4）。
  // ここで import('@shopify/events') と書くと、Shopify の配信時の縮める処理が require(...) に書き換えて失敗する（本番・プレビューで実測）
  var eventsMod = null;
  function loadEvents() {
    if (!eventsMod) {
      eventsMod = new Promise(function (resolve) {
        if (window.__igCartEvents) { resolve(window.__igCartEvents); return; }
        var t = setTimeout(function () { resolve(window.__igCartEvents || null); }, 4000);
        document.addEventListener('ig:cart-events-ready', function () { clearTimeout(t); resolve(window.__igCartEvents); }, { once: true });
      });
    }
    return eventsMod;
  }
  function getJSON(res) { return res.json(); }

  function addToCart(it) {
    var d = drawer();
    var p = it.product || {};
    var v = variantOfItem(it);
    if (!v || !v.available) { renderList(); return; } // 段は「売り切れ」か「色とサイズを選ぶ」＝ここへは来ない（念のため）
    adding[it.id] = true;
    delete notes[it.id];
    renderList();
    var panel = d && d.querySelector('.theme-drawer__dialog');
    var sections = Array.prototype.map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
      return el.dataset.sectionId;
    });

    loadEvents().then(function (ev) {
      var deferred = ev ? ev.CartLinesUpdateEvent.createPromise() : null;
      // ドロワーの器から出す＝スマホ（ドロワーが全画面の窓）では、Horizon はこの窓が閉じてからカートを開く（クイック追加と同じ扱い）
      if (ev && panel) {
        panel.dispatchEvent(new ev.CartLinesUpdateEvent({
          action: 'add',
          context: 'dialog',
          lines: [{ merchandiseId: String(v.id), quantity: 1 }],
          promise: deferred.promise
        }));
      }
      function settle(res, didError) {
        return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(getJSON).then(function (cart) {
          if (deferred) {
            deferred.resolve({
              cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items, source: 'ig-wishlist', itemCount: 1, productId: String(p.id || ''),
                sections: res && res.sections, didError: didError
              }
            });
          }
          return cart;
        });
      }
      return fetch(CART_ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
      }).then(getJSON).then(function (res) {
        if (res && res.status) {
          // 在庫が足りない等＝Shopify の言葉（お客様の言語）で行の下に出す
          return settle(null, true).then(function () { throw new Error(res.description || res.message || ''); });
        }
        return settle(res, false).then(function () { return ev; });
      }).catch(function (err) {
        if (deferred) deferred.resolve({ cart: null, detail: { didError: true } });
        throw err;
      });
    }).then(function (ev) {
      delete adding[it.id];
      say('カートに入れました');
      if (!ev) { window.location.href = CART_URL; return; } // 知らせの仕組みが読めない時は、カートのページで確かめてもらう
      // カートのドロワーが「入れたら開く」設定なら、Horizon がカートを開く＝こちらは閉じて席を譲る（2 面を重ねない・§16.24-1）
      if (document.querySelector('cart-drawer-component[auto-open]')) {
        var dd = drawer();
        // §317-9（デバッグ A4）自前のドロワーが閉じると、ブラウザは焦点を開き手（ヘッダーの印）へ戻す＝開いたカートの中へ移し直す。
        // 誰が閉じるか（こちら・カートを開く Horizon）と順番は画面の幅で変わるので、「こちらが閉じ切り、カートが開いている」状態を
        // 最長 2 秒見張って、そうなった時に焦点がカートの外ならカートの器へ移す
        var wlDialog = dd && dd.querySelector('dialog');
        var tries = 0;
        var moveIntoCart = function () {
          var cd = document.querySelector('#cart-drawer > dialog[open]'); // theme-drawer#cart-drawer の器（cart-drawer-component はその中）
          var mineClosed = !wlDialog || !wlDialog.open;
          if (cd && mineClosed) {
            if (!cd.contains(document.activeElement)) { cd.setAttribute('tabindex', '-1'); cd.focus({ preventScroll: true }); }
            return;
          }
          if (++tries < 20) setTimeout(moveIntoCart, 100);
        };
        if (dd && dd.hasAttribute('open')) dd.close();
        setTimeout(moveIntoCart, 100);
        renderList();
      } else {
        notes[it.id] = { text: 'カートに入れました', ok: true };
        renderList();
        setTimeout(function () { if (notes[it.id] && notes[it.id].ok) { delete notes[it.id]; renderList(); } }, 3000);
      }
    }).catch(function (err) {
      delete adding[it.id];
      notes[it.id] = { text: (err && err.message) || 'カートに入れられませんでした。もう一度お試しください' };
      renderList();
      say(notes[it.id].text);
    });
  }

  function onListClick(e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    var arrow = t.closest('[data-ig-wl-scroll]');
    if (arrow) {
      var track = drawer().querySelector('.ig-wl-checked__track');
      if (track) track.scrollBy({ left: Number(arrow.getAttribute('data-ig-wl-scroll')) * Math.max(track.clientWidth - 48, 96), behavior: 'smooth' });
      return;
    }
    // §317-11 再入荷通知の入口：今開いている商品ページ（同じ種類）へのリンクなら読み込み直さないので、ドロワーを閉じて登録欄を見せる
    var rs = t.closest('.ig-wl-line__add--restock');
    if (rs) {
      var u = new URL(rs.getAttribute('href'), location.href);
      if (u.pathname === location.pathname && u.search === location.search) {
        var dr = drawer();
        if (dr && dr.hasAttribute('open')) dr.close();
        if (location.hash === u.hash) { e.preventDefault(); window.dispatchEvent(new HashChangeEvent('hashchange')); }
      }
      return;
    }
    var addBtn = t.closest('[data-ig-wl-add]');
    if (addBtn && app) {
      e.stopPropagation(); // 描き直しで押したボタンが外れる＝下の削除と同じ理由で、Horizon の「外を押したら閉じる」へ届かせない
      var item = findItem(addBtn.getAttribute('data-ig-wl-add'));
      if (item && !adding[item.id]) addToCart(item);
      return;
    }
    var btn = t.closest('[data-ig-wl-remove]');
    if (!btn || !app) return;
    // Swish は削除を受けた瞬間に台帳の知らせを出し直し、一覧が描き直されて押したボタンが外れる。
    // その後に Horizon の「外を押したら閉じる」判定（utilities.js isClickedOutside）へ届くと、外と見なされてドロワーが閉じる＝ここで止める
    e.stopPropagation();
    var id = btn.getAttribute('data-ig-wl-remove');
    if (removing[id]) return;
    removing[id] = true;
    renderList();
    paintBadges();
    act(function () { return app.state.removeWishlistItem({ wishlistItemId: id }); }).then(function () {
      removing[id] = 'done'; // 台帳の読み直しで消えるまで外したまま（一瞬戻るのを防ぐ）
      say('お気に入りから外しました');
      // 商品ページのボタンは台帳の知らせ（observeWishlist → repaintButtons）で自動で戻る
    }).catch(function () {
      delete removing[id];
      renderList();
      paintBadges();
      say('うまく削除できませんでした。もう一度お試しください');
    });
  }

  /* 排他の取りまとめ役（§16.24-1）。絞り込み・メガメニューの JS と同じ中身で、先に起きた側が作る（二重に作らない） */
  if (!window.__menuX) {
    window.__menuX = {
      register: function (id, closeFn) {
        var handler = function (e) { if (e.detail !== id) closeFn(); };
        document.addEventListener('menu:open', handler);
        return function unregister() { document.removeEventListener('menu:open', handler); };
      },
      announce: function (id) {
        document.dispatchEvent(new CustomEvent('menu:open', { detail: id }));
      }
    };
  }

  /* ================= 起動 ================= */
  function start() {
    bindButtons();
    // ヘッダーの印＝押したらドロワー（Horizon の on:click でなく自前で開く）
    document.addEventListener('click', function (e) {
      var link = e.target instanceof Element ? e.target.closest('.ig-wl-link') : null;
      if (!link) return;
      e.preventDefault();
      toggleDrawer();
    });
    // ほかのドロワーが開いたら閉じる（カートを開いた時など）
    document.addEventListener('theme-drawer:open', function (e) {
      var d = drawer();
      if (d && e.target !== d && d.hasAttribute('open')) d.close();
    });
    if (window.__menuX) {
      window.__menuX.register('wishlist', function () { var d = drawer(); if (d && d.hasAttribute('open')) d.close(); });
    }
    window.addEventListener('resize', function () { var d = drawer(); if (d) { syncOpen(d); updateChecked(d); } });
    // 区画の差し替え（クイックビュー・テーマエディタ）で現れたボタンにも
    document.addEventListener('shopify:section:load', function (e) { bindButtons(e.target); });

    setTimeout(function () { if (!app) { appFailed = true; renderList(); } }, READY_LIMIT);
    whenReady(function (a) {
      app = a;
      appFailed = false;
      // §317-13（2026-10-13 代表の実機「PC側でそのお気に入りを削除しても、スマホ側のお気に入りは削除されない…ログインし直すと、同期されて」）
      // Swish は台帳を端末に覚えておき、ページを開いても取り直さない＝ほかの端末での変更が届かない。
      // ログイン中（台帳がお客様の会員情報に付いている時）だけ、ページを開いた時と、タブに戻った時（30 秒に 1 回まで）に取り直す（Swish の revalidate）
      if (!CFG.guest && a.state && typeof a.state.revalidate === 'function') {
        var lastSync = 0;
        var resync = function () {
          var now = Date.now();
          if (now - lastSync < 30000) return;
          lastSync = now;
          try { Promise.resolve(a.state.revalidate()).catch(function () {}); } catch (e) {}
        };
        resync();
        document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') resync(); });
        window.addEventListener('pageshow', function (e) { if (e.persisted) { lastSync = 0; resync(); } }); // 戻るで出た古い画面（bfcache）も
      }
      document.documentElement.classList.add('ig-wl-ready');
      a.state.observeWishlist({ wishlistId: 'mine' }).subscribe(function (w) {
        wishlist = w || { numItems: 0, items: [] };
        if (failedPending && !(wishlist.items || []).some(isTemp)) failedPending = false; // §402 仮の行が消えたら普段どおりに
        // 削除が済んで台帳からも消えた行は、処理待ちの印を外す
        Object.keys(removing).forEach(function (id) {
          if (removing[id] === 'done' && !(wishlist.items || []).some(function (it) { return it.id === id; })) delete removing[id];
        });
        paintBadges();
        renderList();
        repaintButtons(false);
      });
    });
    // §302-5 商品ページで色やサイズを選び直したら、ハートと選ぶ部品の印を合わせ直す（Horizon が部品を描き直した後に）
    document.addEventListener('shopify:product:select', function (e) {
      repaintButtons(false); // 押した瞬間にハートを今の選択へ合わせる（描き直しの後にもう一度）
      var done = function () { requestAnimationFrame(function () { repaintButtons(false); }); };
      if (e.promise && e.promise.then) e.promise.then(done, done); else done();
    });
    var picker = document.querySelector('#MainContent variant-picker');
    if (picker) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; repaintButtons(false); });
      }).observe(picker, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
